<div *ngIf="horizontalMenu" class="navbar-header d-xl-block d-none">
  <!-- Navbar brand -->
  <ul class="nav navbar-nav flex-row">
    <li class="nav-item">
      <a class="navbar-brand" [routerLink]="['/admin/dashboard']">
        <span class="brand-logo">
          <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" />
        </span>
        <h2 class="brand-text mb-0">{{ coreConfig.app.appName }}</h2>
      </a>
    </li>
  </ul>
  <!--/ Navbar brand -->
</div>


<div class="navbar-container d-flex content">
  <div class="bookmark-wrapper d-flex align-items-center">
    <!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
    <ul class="nav navbar-nav d-xl-none" *ngIf="!coreConfig.layout.menu.hidden">
      <li class="nav-item">
        <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
          <span [data-feather]="'menu'" [class]="'ficon'"></span>
        </a>
      </li>
    </ul>
    <!--/ Menu Toggler -->

    <!-- Toggle skin -->
    <li class="nav-item d-none d-lg-block">
      <a type="button" class="nav-link nav-link-style btn" (click)="toggleDarkSkin()">
        <span [ngClass]="currentSkin === 'dark' ? 'icon-sun' : 'icon-moon'" class="ficon font-medium-5 feather"></span>
      </a>
    </li>


    <!--/ Toggle skin -->
  </div>

  <ul class="nav navbar-nav align-items-center ml-auto">
    <!-- ? Language selection | Uncomment if needed-->
    <!-- <li ngbDropdown class="nav-item dropdown dropdown-language">
      <a class="nav-link dropdown-toggle" id="dropdown-flag" ngbDropdownToggle>
        <i class="flag-icon flag-icon-{{ languageOptions[_translateService.currentLang].flag }}"></i
        ><span class="selected-language">{{ languageOptions[_translateService.currentLang].title }}</span></a
      >
      <div ngbDropdownMenu aria-labelledby="dropdown-flag">
        <a *ngFor="let lang of _translateService.getLangs()" ngbDropdownItem (click)="setLanguage(lang)">
          <i class="flag-icon flag-icon-{{ languageOptions[lang].flag }}"></i> {{ languageOptions[lang].title }}
        </a>
      </div>
    </li> -->
    <!--/ Language selection -->

    <!-- User Dropdown -->
    <div class="d-flex flex-column align-items-center mr-50" *ngIf="isTurkakToken" data-toggle="tooltip" data-placement="top"
      title="Türkak Bağlantısı Aktif">

      <i data-feather="link" class="text-success" style="width: 24px; height: 24px;"></i>

      <small class="text-success font-weight-bold">Türkak</small>
    </div>

    <!-- <app-navbar-cart></app-navbar-cart> -->
    <app-navbar-notification></app-navbar-notification>

    <!-- <app-navbar-cart></app-navbar-cart> -->
    <li ngbDropdown class="nav-item dropdown-user">

      <a class="nav-link dropdown-toggle dropdown-user-link" id="dropdown-user" ngbDropdownToggle
        id="navbarUserDropdown" aria-haspopup="true" aria-expanded="false">
        <div class="user-nav d-sm-flex d-none">
          <span class="user-name font-weight-bolder">{{authServices.isUserNameAndLastName ?? "" }} </span>
          <!-- <span>{{authServices.isUserName?.toUpperCase() ?? "" }}</span> -->
        </div>
        <span class="avatar">
          <div class="avatar bg-primary">
            <div class="avatar-content" *ngIf="authServices.isUserName && authServices.isUserName.length > 0">
              {{authServices.isUserName[0]?.toUpperCase() ?? "" + authServices.isUserName[1]?.toLowerCase() ?? ""}}
            </div>
          </div>
        </span>
      </a>
      <div ngbDropdownMenu aria-labelledby="navbarUserDropdown" class="dropdown-menu dropdown-menu-right">

        <a ngbDropdownItem [href]="'#/admin/user/'+ isId"><span [data-feather]="'hash'"
            [class]="'mr-50'"></span>Hesabım</a>
        <a ngbDropdownItem href="#/admin/company/1"><span [data-feather]="'layout'" [class]="'mr-50'"></span>Firmam</a>
        <a *ngIf="authServices.isEndpointStatus('GET.Reading.GetByIdCustomerSetting')" ngbDropdownItem
          href="#/admin/customer-setting"><span [data-feather]="'settings'" [class]="'mr-50'"></span>Ayarlar</a>
        <div class="dropdown-divider"></div>
        <a ngbDropdownItem [routerLink]="['pages/authentication/login-v2']" (click)="logout()"><span
            [data-feather]="'power'" [class]="'mr-50'"></span>Çıkış Yap</a>
      </div>

    </li>
    <!--/ User Dropdown -->
  </ul>
</div>